export enum VerificationTransactionStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Expired = 'expired',
  Sent = 'sent',
  Unsent = 'unsent',
}
